<template>
  <div>
    <app-collapse accordion>
      <app-collapse-item
        class="border rounded my-1"
        title="اليوم العالمي للسكان"
      >
        <template #header>
          <div class="d-flex w-100 justify-content-between align-items-center">
            <!-- <h4>{{ branch.name_after_publication_ar }}</h4> -->
            <h4>{{ info.name_ar }}</h4>

            <div>
              <b-button
                v-if="info.confirmed === 'A'"
                v-can="{ slug: 'ngo_donors' }"
                class="add_donation"
                variant="success"
                @click="
                  activAddDonation = true;
                  campaign_id = info.id;
                "
              >
                <feather-icon icon="UserPlusIcon" size="12" />
                <span>إضافة متبرع</span>
              </b-button>
              <b-badge v-if="info.confirmed === 'P'" variant="light-warning">
                بانتظار الموافقة
              </b-badge>
              <b-badge v-if="info.confirmed === 'R'" variant="light-danger">
                مرفوض
              </b-badge>

              <b-button
                @click="$emit('editClicked')"
                variant="flat-primary"
                class="btn-icon rounded-circle"
                v-can="{ slug: $route.meta.slug, action: 'U' }"
                :disabled="info.confirmed === 'A'"
                v-if="canAddTransaction"
              >
                <feather-icon size="15" icon="EditIcon" />
              </b-button>

              <b-button
                variant="flat-danger"
                class="btn-icon rounded-circle"
                @click="onDeleteClicked"
                v-can="{ slug: $route.meta.slug, action: 'D' }"
                :disabled="info.confirmed === 'A'"
                v-if="canAddTransaction"
              >
                <feather-icon size="15" icon="Trash2Icon" />
              </b-button>
            </div>
          </div>
        </template>
        <div>
          <div>
            <div>
              <div class="row p-2 bg-white rounded mt-2 mb-3">
                <div class="col-lg-6 col-md-12">
                  <img
                    :src="info.image"
                    class="img_donation"
                    style="width: 400px; height: 200px"
                  />
                  <div class="my-3 row">
                    <div class="col-md-6 mt-2">
                      <b-media
                        no-body
                        style="display: flex; align-items: center"
                      >
                        <b-media-aside class="mr-1">
                          <b-avatar rounded variant="light-primary" size="34">
                            <feather-icon icon="MapPinIcon" size="18" />
                          </b-avatar>
                        </b-media-aside>
                        <b-media-body>
                          <h6>{{ info.governorate ? info.governorate.name_ar :"غير محدد" }}</h6>
                        </b-media-body>
                      </b-media>
                      <b-media no-body class="d-flex align-items-center mt-2">
                        <b-media-aside class="mr-1">
                          <b-avatar rounded variant="light-primary" size="34">
                            <img
                              :src="require(`@/assets/global/time_primary.png`)"
                              width="20"
                              height="20"
                            />
                          </b-avatar>
                        </b-media-aside>
                        <b-media-body>
                          <h6 v-if="info.is_active">
                            انتهاء الحملة بعد
                            {{ info.remaining_time }} يوم
                          </h6>
                          <h6 v-else>حملة منتهية</h6>
                        </b-media-body>
                      </b-media>
                    </div>
                    <div class="col-md-6 m-0">
                      <app-timeline class="m-1 mt-2">
                        <app-timeline-item
                          title="تاريخ بداية الحملة"
                          :subtitle="info.start_date"
                          variant="success"
                        />
                        <app-timeline-item
                          title="تاريخ نهاية الحملة"
                          :subtitle="info.end_date"
                          variant="info"
                        />
                      </app-timeline>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  التفاصيل
                  <div class="mb-5 mt-2">
                    <p class="px-1" v-html="info.description_ar"></p>
                  </div>
                  <div class="pt-1">
                    <div
                      class="font-weight-bold text-center"
                      style="position: relative; top: 20px"
                      v-if="
                        percentageCalculator(
                          info.remaining_amount,
                          info.campaign_type ? info.campaign_amount.replace(/,/g, '') : info.count
                        ) <= 5
                      "
                    >
                      {{
                        "(" +
                        percentageCalculator(
                          info.remaining_amount,
                          info.campaign_type ? info.campaign_amount.replace(/,/g, '') : info.count
                        ) +
                        "%)"
                      }}
                    </div>
                    <b-progress
                      :class="{
                        isActive:
                          percentageCalculator(
                            info.remaining_amount,
                            info.campaign_type
                              ? info.campaign_amount.replace(/,/g, '')
                              : info.count
                          ) >= 5,
                      }"
                      max="100"
                      class="progress-bar-secondary donationProgress mb-2"
                    >
                      <b-progress-bar
                        :value="`${percentageCalculator(
                          info.remaining_amount,
                          info.campaign_type ? info.campaign_amount.replace(/,/g, '') : info.count
                        )}`"
                        :label="`${
                          percentageCalculator(
                            info.remaining_amount,
                            info.campaign_type
                              ? info.campaign_amount.replace(/,/g, '')
                              : info.count
                          ) >= 5
                            ? '(' +
                              percentageCalculator(
                                info.remaining_amount,
                                info.campaign_type
                                  ? info.campaign_amount.replace(/,/g, '')
                                  : info.count
                              ) +
                              '%)'
                            : ''
                        }`"
                        variant="info"
                      />
                    </b-progress>
                  </div>
                  <div class="d-flex justify-content-around my-2">
                    <div class="text-center">
                      <div>تم التبرع بـ</div>
                      <span
                        class="nomber_donation font-weight-bold text-success"
                      >
                        {{
                          info.campaign_type
                            ? (
                              info.campaign_amount.replace(/,/g, '') - info.remaining_amount
                              ).toLocaleString("en-US")
                            : info.count - info.remaining_amount
                        }}
                      </span>
                      <span v-if="info.campaign_type" class="text-success"
                        >ل.س</span
                      >
                    </div>

                    <div class="text-center">
                      <div>
                        {{
                          info.campaign_type
                            ? "المبلغ المتبقي"
                            : "العدد المتبقي"
                        }}
                      </div>
                      <span
                        class="font-weight-bold text-danger nomber_donation"
                        >{{
                          info.remaining_amount.toLocaleString("en-US")
                        }}</span
                      >
                      <span v-if="info.campaign_type" class="text-danger"
                        >ل.س</span
                      >
                    </div>
                  </div>
                  <div class="d-flex justify-content-around">
                    <div class="text-center">
                      <div>نوع الحملة</div>
                      <div
                        class="font-small-4 font-weight-bold"
                        style="margin-top: 9px"
                      >
                        {{ info.campaign_type ? "مادي" : "عيني" }}
                      </div>
                    </div>
                    <div class="text-center">
                      <div>تستهدف</div>
                      <ul
                        class="font-small-4 font-weight-bold"
                        style="margin-top: 9px"
                      >
                        <li
                          v-for="itemCampaign in info.ageCategories"
                          :key="itemCampaign.id"
                        >
                          {{ itemCampaign.name_ar }}
                        </li>
                      </ul>
                    </div>
                    <div class="text-center">
                      <div>عدد المتبرعين</div>
                      <span class="font-large-1 font-weight-bold">{{
                        info.donors_numbers
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- </basc-card> -->
            </div>
          </div>
        </div>
      </app-collapse-item>
    </app-collapse>
    <modal-add-donation
      v-model="activAddDonation"
      :campaign_id.sync="campaign_id"
      :page.sync="currentPage"
    />
  </div>
</template>

<script>
import {
  BCard,
  BImg,
  BButton,
  BRow,
  BCol,
  BFormRadioGroup,
  BFormGroup,
  BFormInput,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BCardText,
  BProgress,
  BProgressBar,
  BModal,
  BBadge,
} from "bootstrap-vue";
import ModalAddDonation from "./ModalAddDonation.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { mapGetters } from "vuex";
export default {
  props: ["info", "currentPage"],
  components: {
    BCard,
    BImg,
    BButton,
    AppCollapse,
    AppCollapseItem,
    BRow,
    BCol,
    BFormRadioGroup,
    BFormGroup,
    BFormInput,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    AppTimeline,
    AppTimelineItem,
    BCardText,
    BProgress,
    BProgressBar,
    BModal,
    ModalAddDonation,
    BBadge,
  },

  data: () => ({
    campaign_id: null,
    activAddDonation: false,
  }),
  computed: {
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),
  },
  methods: {
    onDeleteClicked() {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف الحملة؟", {
          title: "تأكيد حذف الحملة",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) this.$emit("deleteClicked");
        });
    },

    percentageCalculator(remaining_amount, campaign_amount) {
      return parseInt(
        ((campaign_amount - remaining_amount) / campaign_amount) * 100
      );
    },
  },
};
</script>
<style lang="scss">
.donationProgress {
  height: 15px;
  .progress-bar {
    position: static;
    height: 15px;
    background-color: #048042 !important;
  }
}

.isActive {
  margin-top: 20px;
}
.add_donation {
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 11px;
  span {
    margin-left: 3px;
  }
}
</style>
